/* Nuvian · Trouver mon appareil. Le CSS (:has) affiche le résultat ; ce script coche le 1er besoin du
   monde choisi, annonce le produit, fait un fondu (View Transitions, si dispo et sans reduced-motion)
   et, au toucher sur mobile, fait défiler jusqu'au résultat. */
if (!customElements.get('nuvian-finder')) {
  customElements.define(
    'nuvian-finder',
    class extends HTMLElement {
      connectedCallback() {
        this.live = this.querySelector('[data-live-region]');
        this.pt = 'mouse';
        this.addEventListener('pointerdown', (e) => (this.pt = e.pointerType), { passive: true });
        this.addEventListener('keydown', () => (this.pt = 'key'));
        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('change', (e) => this.onChange(e.target));
      }

      reduced() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      onClick(e) {
        const i = e.target;
        if (!document.startViewTransition || this.vt || this.reduced()) return;
        if (!(i instanceof HTMLInputElement) || i.type !== 'radio' || !i.name) return;
        e.preventDefault();
        const root = document.documentElement;
        root.classList.add('nv-vt-finder');
        this.vt = true;
        const t = document.startViewTransition(() => {
          i.checked = true;
          this.onChange(i);
        });
        t.finished.finally(() => {
          root.classList.remove('nv-vt-finder');
          this.vt = false;
        });
      }

      onChange(input) {
        if (input.hasAttribute('data-world-input')) {
          const need = this.querySelector(`input[data-world="${input.value}"]:not([data-world-input])`);
          if (need && !this.current(input.value)) need.checked = true;
          this.announce(false);
        } else if (input.dataset.world) {
          this.announce(true);
        }
      }

      current(world) {
        return this.querySelector(`input[data-world="${world}"]:not([data-world-input]):checked`);
      }

      announce(scroll) {
        const w = this.querySelector('[data-world-input]:checked');
        const n = w && this.current(w.value);
        const r = n && this.querySelector(`[data-need="${n.value}"]`);
        if (!r) return;
        const t = r.querySelector('h3');
        if (this.live && t) this.live.textContent = `${this.dataset.live} ${t.textContent.trim()}`;
        if (!scroll || this.pt !== 'touch' || window.innerWidth >= 990) return;
        const box = r.getBoundingClientRect();
        if (box.top > window.innerHeight * 0.7 || box.bottom < 0) {
          r.scrollIntoView({ behavior: this.reduced() ? 'auto' : 'smooth', block: 'center' });
        }
      }
    }
  );
}
